import React from 'react';
import styled from 'styled-components';
import { truncate } from '../../helpers/stringHelpers';
import Flex from '../Flex';
import theme from '../theme';
import DownloadableFile from '../DownloadableFile';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  background: ${theme.colors.NEU_50};
  border: 1px solid ${theme.colors.NEU_100};
  border-radius: 8px;
`;

const FlexStyled = styled(Flex)`
  ${({ $asButton }) =>
    $asButton &&
    `
    flex-direction: row;
    flex-wrap: wrap;
  `}
`;

const FileRow = styled(Flex)`
  padding: 6px 0;

  &:not(:last-child) {
    border-bottom: 1px solid ${theme.colors.NEU_100};
  }
`;

const AttachmentList = ({ files, themeColor, variant = 'attach', gap = '8' }) => {
  // Normalize files to always be an array
  const fileList = Array.isArray(files) ? files : files && Object.keys(files).length > 0 ? [files] : [];

  if (!fileList.length) {
    return null;
  }

  const asButton = variant === 'button';

  return (
    <Container>
      <FlexStyled direction='column' align='stretch' gap={gap} $asButton={asButton}>
        {fileList.map((file, index) => {
          const fileName = file.name || file.title || 'File';
          return (
            <FileRow align='center' gap={10} key={file.id ? `${file.id}-${index}` : index}>
              {asButton ? (
                <DownloadableFile.AsButton $bgcolor={themeColor || theme.colors.PRIMARY} $variant='customized' label={truncate(fileName, 50)} file={file} />
              ) : (
                <DownloadableFile.AsAttach label={truncate(fileName, 50)} file={file} />
              )}
            </FileRow>
          );
        })}
      </FlexStyled>
    </Container>
  );
};

export default AttachmentList;
